<template>
  <div id="domain">
    <div style="text-align: right;">
      <el-form :model="keywords" size="small" inline>
        <el-form-item label="关键词">
          <el-input />
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="getTableDate(1)"><i class="fa fa-search"></i>域名搜索</el-button>
            <el-button type="primary" @click="newShow = true"><i class="fa fa-lock"></i>绑定新域名</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </div>
    <div style="display: block">
      <el-table :data="tableDate" v-loading="tableLoad" stripe>
        <el-table-column prop="id" label="id"></el-table-column>
        <el-table-column prop="domain.name" label="域名"></el-table-column>
        <el-table-column label="域名状态">
          <template slot-scope="scope">
            <el-button type="text" :style="{color: scope.row.domain.status === 'active' ? 'green' : 'red', 'font-weight': 'bold'}">{{scope.row.domain.status}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="域名NS">
          <template slot-scope="scope">
            {{scope.row.domain.original_name_servers.join(';')}}
          </template>
        </el-table-column>
        <el-table-column label="需绑定NS">
          <template slot-scope="scope">
            {{scope.row.domain.name_servers.join(';')}}
          </template>
        </el-table-column>
        <el-table-column label="域名可用">
          <template slot-scope="scope">
            <el-button :type="scope.row.fixed ? 'success' : 'warning'" size="mini" round>{{scope.row.fixed ? '域名可用' : '待检测'}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="SSL证书">
          <template slot-scope="scope">
            <el-button :type="scope.row.ssl.enabled ? 'success' : 'warning'" size="mini" round>{{scope.row.ssl.enabled ? '启用SSL' : '禁用SSL'}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="HTTPS跳转">
          <template slot-scope="scope">
            <el-button :type="scope.row.alwaysHttps.value === 'on' ? 'success' : 'warning'" size="mini" round>{{scope.row.alwaysHttps.value === 'on' ? '强制跳转' : '无需跳转'}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="域名管理" fixed="right" style="text-align: right;">
          <template slot-scope="scope">
            <el-button-group v-if="!scope.row.fixed">
              <el-button type="text" @click="checkfixed(scope.row.id)">域名状态检测</el-button>
              <el-button type="text" @click="delDomain(scope.row.id)">删除域名</el-button>
            </el-button-group>
            <el-button-group v-else>
              <el-button type="text" @click="exAwayHttps(scope.row.id, scope.row.alwaysHttps.value === 'on' ? 'off' : 'on' )">{{scope.row.alwaysHttps.value === 'on' ? '关闭HTTPS跳转' : '开启HTTPS跳转'}}</el-button>
              <el-button type="text" @click="initDomain(scope.row)">域名解析</el-button>
              <el-button type="text" @click="onnkeyDnsRecord(scope.row.id)">启用店铺根域解析</el-button>
              <el-button type="text" @click="force3w(scope.row.id)">强制跳转至3w</el-button>
              <el-button type="text" @click="exSSLState(scope.row.id, !scope.row.ssl.enabled)">{{scope.row.ssl.enabled ? '禁用SSL证书' : '启用SSL证书'}}</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="getTableDate"
        :current-page.sync="tablePageinfo.page"
        :page-size="15"
        layout="total, prev, pager, next"
        :total="tablePageinfo.total">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="newShow" width="40%">
      <h3 slot="title">绑定域名至系统</h3>
      <el-form>
        <el-form-item>
          <el-input v-model="newDomain" placeholder="请输入顶级域名以绑定至系统"/>
        </el-form-item>
        <el-form-item>
          <el-input type="textarea" :rows="3" v-model="ns" readonly/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="handleDomain">+ 提交新的域名</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="recordBroadShow">
      <h3 slot="title">{{editDomain.domain.name}}域名解析管理</h3>
      <div style="display: block;">
        <el-form :model="newRecored" style="display: flex; justify-content: flex-start;" size="small" ref="newRecord">
          <el-form-item label="解析类型" prop="type" required>
            <el-select v-model="newRecored.type">
              <el-option label="A" value="A"/>
              <el-option label="AAAA" value="AAAA"/>
              <el-option label="CNAME" value="CNAME"/>
              <el-option label="TXT" value="TXT"/>
              <el-option label="SRV" value="SRV"/>
              <el-option label="LOC" value="LOC"/>
              <el-option label="MX" value="MX"/>
              <el-option label="NS" value="NS"/>
              <el-option label="SPF" value="SPF"/>
              <el-option label="CERT" value="CERT"/>
              <el-option label="DNSKEY" value="DNSKEY"/>
              <el-option label="DS" value="DS"/>
              <el-option label="NAPTR" value="NAPTR"/>
              <el-option label="SMIMEA" value="SMIMEA"/>
              <el-option label="SSHFP" value="SSHFP"/>
              <el-option label="TLSA" value="TLSA"/>
              <el-option label="URI" value="URI"/>
            </el-select>
          </el-form-item>
          <el-form-item label="子域名" prop="name" required>
            <el-input v-model="newRecored.name" placeholder="根域名请使用'@'"/>
          </el-form-item>
          <el-form-item style="flex: 1;" label="解析值" prop="content" required>
            <el-input v-model="newRecored.content" placeholder="请输入解析值"/>
          </el-form-item>
          <el-form-item v-if="newRecored.type === 'MX' || newRecored.type === 'SRV'" label="权重值" prop="priority" required>
            <el-input v-model="newRecored.priority" placeholder="请输入解析权重值"/>
          </el-form-item>
          <el-form-item label="使用CDN" prop="proxied" style="text-align: center!important;" required>
            <el-switch v-model="newRecored.proxied" :active-value="true" :inactive-value="false"></el-switch>
          </el-form-item>
          <el-form-item label="操作">
            <el-button type="primary" @click="handleRecord('newRecord')">新增域名解析</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="dmData" stripe v-loading="tableDomainLoad">
        <el-table-column prop="id" label="id"></el-table-column>
        <el-table-column prop="name" label="域名"></el-table-column>
        <el-table-column prop="type" label="解析类型"></el-table-column>
        <el-table-column prop="content" label="解析值"></el-table-column>
        <el-table-column prop="ttl" label="生效时长"></el-table-column>
        <el-table-column label="锁定">
          <template slot-scope="scope">
            {{scope.row.locked ? '锁定' : '未锁定'}}
          </template>
        </el-table-column>
        <el-table-column label="云加速">
          <template slot-scope="scope">
            <el-button :type="scope.row.proxied ? 'success' : 'danger'" size="mini" round>{{scope.row.proxied ? '云加速' : '仅解析'}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="域名管理">
          <template slot-scope="scope">
            <el-button-group>
              <el-button v-if="scope.row.proxiable" type="text">{{scope.row.proxied ? '禁用CDN' : '启用CDN'}}</el-button>
              <el-button type="text" @click="removeRecord(scope.row.id)">删除</el-button>
              <el-button type="text">编辑</el-button>
              <el-button @click="bindDnsToShop(scope.row.name)" v-if="scope.row.type === 'CNAME' && scope.row.content === 'domain.bigevy.com'" type="text">绑定域名到商城</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Domains',
  data () {
    return {
      tableData: [],
      tablePageinfo: {page: 1, total: 0},
      keywords: {},
      newCurrr: {},
      newShow: false,
      newRecored: {proxied: true},
      newRecordsShow: false,
      newDomain: undefined,
      ns: '请修改域名NS为如下记录:\njosh.ns.cloudflare.com\nzoe.ns.cloudflare.com',
      tableLoad: false,
      dmData: [],
      tableDomainLoad: false,
      editDomain: {domain: {name: ''}},
      recordBroadShow: false
    }
  },
  mounted () {
    this.getTableDate(1)
  },
  methods: {
    /**
     * 强制www
     */
    force3w: function (dmId) {
      var that = this
      var para = {}
      para.dmId = dmId
      para.method = 'base.forceTo3W'
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        if (ret.data.data.code === 200) {
          that.$message.success('强制跳转www成功')
        } else {
          that.$message.error(ret.body.data.result.errors[0].message)
        }
      })
    },
    exAwayHttps: function (dmId, stateCode) {
      var that = this
      var para = {}
      para.dmId = dmId
      para.stateCode = stateCode
      para.method = 'base.exchangeDomainAlwayHttps'
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        if (ret.data.data.code === 200) {
          that.$message.success('修改强制https状态成功')
          that.getTableDate(that.tablePageinfo.page)
        } else {
          that.$message.error('修改强制https状态失败，请稍后重试')
        }
      })
    },
    /**
     * 绑定域名到店铺
     */
    bindDnsToShop: function (domain) {
      var that = this
      var para = {}
      para.domain = domain
      para.method = 'base.fixDomainToShop'
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        if (ret.data.data.code === 200) {
          that.$message.success('绑定域名到店铺成功')
        } else {
          that.$message.error('绑定域名到店铺失败，请稍后重试')
        }
      })
    },
    /**
     * 删除解析记录
     */
    removeRecord: function (rId) {
      var that = this
      var para = {}
      para.dmId = that.editDomain.id
      para.recordId = rId
      para.method = 'base.deleteDnsRecords'
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        if (ret.data.data.code === 200) {
          that.$message.success('删除域名解析记录成功')
          that.getDomainTableDate(1)
        } else {
          that.$message.error('删除域名解析记录失败，请稍后重试')
        }
      })
    },
    /**
     * 新增解析记录
     */
    handleRecord: function (formName) {
      var that = this
      that.$refs[formName].validate(function (valid) {
        if (valid) {
          var para = that.newRecored
          para.dmId = that.editDomain.id
          para.method = 'base.addDnsRecords'
          that.$pageloading()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.$loadend()
            if (ret.data.data.code === 200) {
              that.$message.success('新增域名解析记录成功')
              that.getDomainTableDate(1)
            } else {
              that.$message.error('新增域名解析记录失败，请稍后重试')
            }
          })
        }
      })
    },
    /**
     * 域名解析初始化
     * @param row
     */
    initDomain: function (row) {
      this.editDomain = row
      this.recordBroadShow = true
      this.getDomainTableDate(1)
    },
    /**
     * 域名分页
     * @param page
     */
    getDomainTableDate: function (page) {
      var that = this
      var para = {}
      para.method = 'base.getDoaminRecords'
      Object.assign(para, that.keywords)
      para.page = page
      para.num = 15
      para.dmId = that.editDomain.id
      that.tableDomainLoad = true
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.tableDomainLoad = false
        that.dmData = ret.body.data
      })
    },
    /**
     * 一键生成店铺解析记录
     */
    onnkeyDnsRecord: function (dmId) {
      var that = this
      var para = {}
      para.dmId = dmId
      para.method = 'base.onnKeyDnsRecord'
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        if (ret.data.data.code === 200) {
          that.$message.success('一键域名解析成功')
          that.getTableDate(that.tablePageinfo.page)
        } else {
          that.$message.error('一键域名解析失败，请使用普通方式解析')
        }
      })
    },
    /**
     * 检测域名是否可用
     */
    checkfixed: function (dmId) {
      var that = this
      var para = {}
      para.dmId = dmId
      para.method = 'base.cheakDomainState'
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        if (ret.data.data.code === 200) {
          that.$message.success('域名已经激活成功')
          that.getTableDate(that.tablePageinfo.page)
        } else {
          that.$message.error('域名尚未激活')
        }
      })
    },
    /**
     * 交换域名SSL证书状态
     */
    exSSLState: function (dmId, state) {
      var that = this
      var para = {}
      para.dmId = dmId
      para.sslState = state
      para.method = 'base.exchangeDomainSSLStatus'
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        if (ret.data.data.code === 200) {
          that.$message.success('域名证书状态修改成功')
          that.getTableDate(that.tablePageinfo.page)
        } else {
          that.$message.error('域名证书修改失败')
        }
      })
    },
    /**
     * 删除域名
     */
    delDomain: function (dmId) {
      var that = this
      var para = {}
      para.dmId = dmId
      para.method = 'base.removeDomain'
      that.$pageloading()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        if (ret.data.data.code === 200) {
          that.$message.success('域名删除成功')
          that.getTableDate(that.tablePageinfo.page)
        } else {
          that.$message.error('域名删除失败')
        }
      })
    },
    /**
     * 域名分页
     * @param page
     */
    getTableDate: function (page) {
      var that = this
      var para = {}
      para.method = 'base.getDoaminPage'
      Object.assign(para, that.keywords)
      para.page = page
      para.num = 15
      that.tableLoad = true
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.tableLoad = false
        that.tableDate = ret.body.data.data
        that.tablePageinfo.page = page
        that.tablePageinfo.total = ret.body.data.total
        that.shop = ret.body.data.shop
      })
    },
    /**
     * 绑定新域名
     */
    handleDomain: function () {
      var that = this
      if (that.newDomain) {
        var para = {}
        para.domain = that.newDomain
        para.method = 'base.addDoamin'
        that.$pageloading()
        that.$http.post(that.$apiurl, para).then(function (ret) {
          that.$loadend()
          if (ret.data.data.code === 200) {
            that.$message.success('新增域名成功')
            that.getTableDate(1)
            that.newShow = false
          } else {
            that.$message.error(ret.body.data.msg)
          }
        })
      } else {
        that.$message.error('请先行录入域名')
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/merchant/Domains.vue